import React, { useMemo } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Stack, Typography } from "@mui/material";
import { capitalize } from "lodash";

import { ClassificationPopoverContent } from "./components/content/ClassificationPopoverContent";
import { DatePopoverContent } from "./components/content/DatePopoverContent";
import { InvestorPopoverContent } from "./components/content/InvestorPopoverContent";
import { ParameterPopoverContent } from "./components/content/ParameterPopoverContent";
import { ValuePopoverContent } from "./components/content/ValuePopoverContent";
import { IChangeSpecificRecommendationValue, IOpenedCell, RecommendationField } from "./context/AiData-context";

export interface PopoverContentProps {
  openedCell: IOpenedCell | null;
  setOpenedCell: React.Dispatch<React.SetStateAction<IOpenedCell | null>>;
  onChangeSpecificRecommendationValue: (data: IChangeSpecificRecommendationValue) => void;
}

export const PopoverContent: React.FC<PopoverContentProps> = ({
  openedCell,
  setOpenedCell,
  onChangeSpecificRecommendationValue
}) => {
  if (!openedCell) return null;
  const content = useMemo(() => {
    switch (openedCell.selectedField) {
      case RecommendationField.investor:
        return (
          <InvestorPopoverContent
            openedCell={openedCell}
            setOpenedCell={setOpenedCell}
            onChangeSpecificRecommendationValue={onChangeSpecificRecommendationValue}
          />
        );
      case RecommendationField.value:
        return (
          <ValuePopoverContent
            openedCell={openedCell}
            setOpenedCell={setOpenedCell}
            onChangeSpecificRecommendationValue={onChangeSpecificRecommendationValue}
          />
        );
      case RecommendationField.measure:
        return (
          <ParameterPopoverContent
            openedCell={openedCell}
            setOpenedCell={setOpenedCell}
            onChangeSpecificRecommendationValue={onChangeSpecificRecommendationValue}
          />
        );
      case RecommendationField.date:
        return (
          <DatePopoverContent
            openedCell={openedCell}
            setOpenedCell={setOpenedCell}
            onChangeSpecificRecommendationValue={onChangeSpecificRecommendationValue}
          />
        );
      case RecommendationField.classification:
        return (
          <ClassificationPopoverContent
            openedCell={openedCell}
            setOpenedCell={setOpenedCell}
            onChangeSpecificRecommendationValue={onChangeSpecificRecommendationValue}
          />
        );
    }
  }, [openedCell.selectedField]);
  if (!content) return null;

  return (
    <Stack sx={{ gap: "20px", p: "24px", boxShadow: "sm", borderRadius: "8px" }}>
      <Stack sx={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
        <Typography sx={{ fontSize: "18px", fontWeight: 400, color: "#071F35", lineHeight: "24px" }}>
          {capitalize(openedCell.selectedField || "")}
        </Typography>
        <IconButton onClick={() => setOpenedCell(null)}>
          <CloseIcon />
        </IconButton>
      </Stack>
      {content}
    </Stack>
  );
};
